<template>
  <DBox :id="'cmp-distribution_account_sidewindow_setup2'" :addButton="false">
    <div class="ut-fc">
       <Dropdown2
            style="flex:1"
            id="default_order_type"
            :label="$dft.capHead($t('default_order_type'))"
            :placeholder="'Select ' + $dft.capHead($t('default_order_type'))"
            :disabled="false"
            :options="orderTypeTV||[]"
            :selected="
            orderTypeTV.find(
                (e) => e.value == selectedAccountsDetails.account.default_order_type
            )
            "
            @selectedChange="(e) => onDropdownChange('default_order_type', e)"
            :lw="'130px'"
        />
        <Dropdown2
            style="flex:1"
            id="default_stock_account"
            :label="$dft.capHead($t('default_stock_account'))"
            :placeholder="'Select ' + $dft.capHead($t('default_stock_account'))"
            :disabled="false"
            :options="contraAccountTV||[]"
            :selected="
            contraAccountTV.find(
                (e) => e.value == selectedAccountsDetails.account.contra_account_id
            )
            "
            @selectedChange="(e) => onDropdownChange('contra_account_id', e)"
            :lw="'130px'"
        />
        <Dropdown2
            style="flex:1"
            id="shipping_type_id"
            :label="$dft.capHead($t('default_shipping'))"
            :placeholder="'Select ' + $dft.capHead($t('default_shipping'))"
            :disabled="false"
            :options="shippinTypeTV||[]"
            :selected="
            shippinTypeTV.find(
                (e) => e.value == selectedAccountsDetails.account.shipping_type_id
            )
            "
            @selectedChange="(e) => onDropdownChange('shipping_type_id', e)"
            :lw="'130px'"
        />
        <Dropdown2
            style="flex:1"
            id="pricelist_id"
            :label="$dft.capHead($t('pricelist'))"
            :placeholder="'Select ' + $dft.capHead($t('pricelist'))"
            :disabled="false"
            :options="priceListsTV||[]"
            :selected="priceListsTV.find(
                (e) => e.value == selectedAccountsDetails.account.pricelist_id
            )
            "
            @selectedChange="(e) => onDropdownChange('pricelist_id', e)"
            :lw="'130px'"
        />   
        <TextField2
          style="flex:1"
          id="price_list_discount"
           :label="$dft.capHead($t('discount'))"
          :placeholder="$dft.capHead($t('discount'))"
          :value="selectedAccountsDetails.account.price_list_discount"
          @blur="(e) => onTextFieldValueChange(e)"
          :lw="'130px'"
        />
        
        <TextField2
          style="flex:1"
          id="identifier"
          :label="$dft.capHead($t('identifier'))"
          :placeholder="$dft.capHead($t('identifier'))"
          :value="selectedAccountsDetails.account.identifier"
          @blur="(e) => onTextFieldValueChange(e)"
          :lw="'130px'"
          :bb="'none'"
        />
      
    </div>
  </DBox>
</template>
<script>
import { createTV, tv } from "../../../../models/text-value.model";

export default {
  props: {
    selectedAccountsDetails: {
      type: Object,
    },
  },

  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
    };
  },
  computed:{
    orderTypeTV:function(){
      return createTV(this.selectedAccountsDetails.order_types||[],"label","value")||[];
    },
    contraAccountTV:function(){
      return createTV(this.selectedAccountsDetails.contra_accounts||[],"account_name","account_id")||[]
    },
    shippinTypeTV:function(){
      return createTV(this.selectedAccountsDetails.shipping_types||[],"shipping_type","shipping_type_id")||[]
    },
    priceListsTV:function(){
      return createTV(this.selectedAccountsDetails.price_lists||[],"price_list_name","price_list_id")||[]
    }
  },
  methods: {
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
    },

    onDropdownChange: function (name, e) {
      const payload = {
        name: name,
        value: e.value,
      };
      this.$emit("changed", payload);
      
    },
  },

};
</script>
<style lang="scss">
.cmp-licencing-licence-accounts-sidewindow-account_setup {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
